import { create } from 'zustand';
import type { Organisation } from '../types';

type OrgState = {
  org: Organisation | null;
  setOrg(org: Organisation | null): void;
};

/** The current organisation. Loaded once after sign-in; shown in the sidebar switcher. */
export const useOrgStore = create<OrgState>((set) => ({
  org: null,
  setOrg: (org) => set({ org }),
}));
